import Pages from './pages/Pages';
import Navbar from './components/Navbar';
import {Route,Routes} from 'react-router-dom';
import PlayersPage from './pages/PlayersPage';
import useMediaQuery from './hooks/useMediaQuery';
import { useState,createContext } from 'react';
import './App.css';

export const SelectedPageContext = createContext({});

function App() {
  const [selectedPage,setSelectedPage] = useState("home");
  const isDesktop = useMediaQuery("(min-width: 1060px)");
  return (
    <div className="font-arvo">
      <SelectedPageContext.Provider value={{setSelectedPage}}>
        <Navbar selectedPage={selectedPage} setSelectedPage={setSelectedPage} />
        <Pages />
      </SelectedPageContext.Provider>
    </div>
  );
}

export default App;
